import React, { FC } from 'react';
import { Box, HStack } from '@chakra-ui/react';

type Item = { title: string; value: string };

interface Props {
  items: Item[];
  onSelect: (val: string) => void;
  selected: string;
}

export const VaultTags: FC<Props> = ({ items, onSelect, selected }) => {
  return (
    <HStack gap={3}>
      {items.map(item => (
        <Box
          onClick={() => {
            onSelect(item.value);
          }}
          key={item.title}
          sx={{
            padding: '8px 24px',
            borderRadius: '24px',
            border: '1px solid',
            borderColor: item.value === selected ? 'orange' : 'neutral.400',
            background: 'neutral.700',
            color: item.value === selected ? 'orange' : 'neutral.400',
            gap: '12px',
            cursor: 'pointer',
            fontSize: '14px',
            // height: '44px',
            textTransform: 'capitalize',
            display: 'flex',
            alignItems: 'center',
            transition: 'all 0.2s ease'
          }}
          _hover={{
            filter: 'brightness(120%)'
          }}
        >
          {item.title}
        </Box>
      ))}
    </HStack>
  );
};
